














































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import LogoCompany from "@/components/generics/LogoCompany.vue";
import _ from "lodash";
import { mapGetters } from "vuex";
import PasswordExpired from "@/components/menu/header-top/pass-expired/PasswordExpired.vue";
import crypto from 'crypto-browserify';

declare var mApp: any;

@Component({
  name: "SwitchUser",
  components: {
    LogoCompany,
    PasswordExpired,
  },

  computed: {
    ...mapGetters(["getUser", "getRelated"]),
  },
})
export default class SwitchUser extends Vue {
  @Prop({ required: false }) isPasswordExpired: Boolean;

  public readonly EMPLOYEE_PROFILE = 1;
  public readonly ADMIN_PROFILE = 2;

  getRelated!: any[];
  getUser!: any;
  domain: string;
  country: string;
  usersRelated: any;
  currentUser: any;
  selected: any;
  blockedUsers: any;
  contentHeight: object;

  data() {
    return {
      country: "",
      usersRelated: "",
      currentUser: "",
      selected: {},
      blockedUsers: [],
      contentHeight: {
        maxHeight: "570px",
      },
    };
  }

  created() {
    this.usersRelated = [...this.getRelated]

    //Get current user
    let current = _.filter(this.usersRelated, (user) => {
      return user.id === this.getUser.id;
    });
    this.currentUser = current[0];

    // Get blocked users by IP
    let blocked = _.filter(this.usersRelated, (user) => {
      return user.blocked_by_ip === true;
    });
    this.blockedUsers = blocked;

    // Remove blocked users from related array
    _.remove(this.usersRelated, (user) => {
      return user.blocked_by_ip === true;
    });

    setTimeout(() => {
      this.getContentHeight();
    }, 100);
  }

  isVisible(perfil, item) {
    return (
      (perfil.id_perfil_tipo === this.EMPLOYEE_PROFILE ||
        perfil.id_perfil_tipo === this.ADMIN_PROFILE) &&
      ((item.id === this.currentUser.id &&
        perfil.id_perfil_tipo !== this.ADMIN_PROFILE) ||
        item.id !== this.currentUser.id)
    );
  }

  switchUser(user, perfil, domain) {
    this.selected = {
      user: user,
      perfil: perfil,
      domain: domain,
    };
    let dominio = !domain ? "www.turecibo.com.ar" : domain;
    this.$emit("switch", user, perfil, dominio);
  }

  getProfileName(profile: number) {
    if (profile === this.EMPLOYEE_PROFILE)
      return this.$t("message.switch_user_profile_employee");
    else if (profile === this.ADMIN_PROFILE)
      return this.$t("message.switch_user_profile_rrhh");
  }

  updated() {
    if (typeof mApp !== "undefined") mApp.init({});
  }

  goToDashboard() {
    this.switchUser(
      this.selected.user,
      this.selected.perfil,
      this.selected.domain
    );
  }

  getContentHeight() {
    let modal = document.getElementsByClassName("zt-modal")[0].clientHeight;
    this.contentHeight = { maxHeight: `${modal - 58}px` };
  }

  getLogoUrl(id:any) {
     const random = '?v=' + new Date().getTime()
        function md5(str:string) {
            const hash = crypto.createHash('md5');
            hash.update(str);
            return hash.digest('hex');
          }

        const id_company_md5 ='/' + md5(id.toString()) 
       return  `${window.trcb.publicDevURL}/company/logo/${id + id_company_md5 + random}`
  }
}
